import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledPageLayout = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: ${breakpoints.md}px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const StyledInfographicsContainer = styled.div`
  min-width: 325px;

  @media (max-width: ${breakpoints.md}px) {
    flex: none;
  }
`;

export const StyledTableContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StyledApplicationsPageWrapper = styled.div`
  .hide-mobile-filter {
    @media (max-width: ${breakpoints.lg}px) {
      display: none;
    }
  }
`;

export const StyledApplicationsInfographics = styled.div`
  border: 1px solid ${({ theme }) => theme.border};
  background-color: ${({ theme }) => theme.tableSecondRowColor};
  border-radius: 5px;
  padding: 20px;

  .product-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    button {
      flex: 1;
    }
  }

  .product-row {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: 20px;
  }

  .infographics-title {
    margin: 10px 0 15px 0;
  }

  .product-header {
    display: flex;
    flex-direction: column;
    align-items: start;
    color: ${({ theme }) => theme.black};

    label {
      margin: 0;
    }
  }

  .progress-container {
    display: flex;
    justify-content: center;

    .ant-progress-circle .ant-progress-text {
      color: ${({ theme }) => theme.colorText} !important;
    }
  }

  .selected-products {
    color: ${({ theme }) => theme.textSecondary};
  }

  @media (max-width: ${breakpoints.lg}px) {
    padding: 10px;

    .infographics-title {
      margin: 0;
    }

    .product-item + div[aria-hidden="true"] {
      display: none;
    }

    .product-item {
      border-bottom: 1px solid ${({ theme }) => theme.border};
      padding-bottom: 10px;
    }

    .buttons {
      margin-top: 0;
    }
  }
`;
